import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import { toast } from "react-toastify";
import { Route, Routes, useNavigate } from "react-router-dom";
import UserService from "../services/UserService";
import Footer from "../component/common/Footer";
import Sidebar from "../component/common/Sidebar";
import Header from "../component/common/Header";
import UserDashboard from "./UserDashboard";
import ChangePasswordModal from "../component/formModal/ChangePasswordModal";
import WebsiteDashboard from "./WebsiteDashboard";
import BlogDashboard from "./BlogDashboard";

const Dashboard = () => {
    const { user, isLoggedIn, logout } = useContext(AuthContext);
    const [loginUserDetail, setLoginUserDetail] = useState(null);
    //const [activeComponent, setActiveComponent] = useState('userDashboard'); // To control rendering
    const navigate =  useNavigate();
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate('/login');
        }
        if (user) {
            fetchLoginUser();
        }
    }, [isLoggedIn, user, navigate]);
    
    const fetchLoginUser = async () => {
      try {
          const response = await UserService.getLogInUser();
          setLoginUserDetail(response);
      } catch (error) {
          console.error('Error fetching data:', error);
          setLoginUserDetail(null)
          logout();
          navigate('/login');
      }
    }

    const handleLogout = () => {
        toast.info('Logout Success.')
        logout();
        navigate('/login');
    };

    return(
      <div className="d-flex" style={{ minHeight: '100vh' }}>
      {/* Sidebar */}
      <Sidebar user={loginUserDetail} />

      {/* Main Content */}
      <div className="flex-grow-1 d-flex flex-column">
        <Header onLogout={handleLogout} showChangePasswordModal={() => setShowChangePasswordModal(true)} />

        <main className="flex-grow-1 p-4">
        <Routes>
            {/* Define routes for each dashboard section */}
            <Route path="/user-dashboard" element={<UserDashboard user={loginUserDetail} />} />
            <Route path="/website-dashboard" element={<WebsiteDashboard user={loginUserDetail} />} />
            <Route path="/blog-dashboard" element={<BlogDashboard user={loginUserDetail} />} />
            {/* Add more routes as needed for additional sections */}
          </Routes>
        </main>

        {showChangePasswordModal && (
              <ChangePasswordModal
                user={loginUserDetail}
                onClose={() => setShowChangePasswordModal(false)}
              />
        )}

        <Footer />
      </div>
    </div>
    );
}

export default Dashboard;